export function initTransitions($) {


	$('.gb-grid-wrapper').each(function(n, wrap) {
		$('> .gb-grid-column', wrap).each(function(n, item){
			$(item).attr('data-aos', 'fade-up')
				.attr('data-aos-delay', 200 * n);
		});
	});

	$('.wp-block-cover').each(function(n, wrap) {
		$('> .wp-block-cover__inner-container', wrap).each(function(n, item){
			$(item).attr('data-aos', 'fade-left');
		});
	});

	$('.wp-block-pullquote').each(function(n, wrap) {
		$(wrap).attr('data-aos', 'fade-up');
	});


	$('.above-footer').each(function(n, wrap) {
		$(wrap).attr('data-aos', 'fade-up');
	});

	$('.has-section-heading-font-size').each(function(n, wrap) {
		$(wrap).attr('data-aos', 'fade-up');
	});

	$('.wp-block-embed').each(function(n, wrap) {
		$(wrap).attr('data-aos', 'fade-up');
	});

	$('.home-hero-content').each(function(n, wrap) {
		$(wrap).attr('data-aos', 'fade-right');
	});


}